import { EventsChannel } from "./EventsChannel";
export class EventsChannelFactory {
    constructor(eventsService) {
        this.eventsService = eventsService;
    }
    createEventsChannel(channelPrefix) {
        return new EventsChannel(this.eventsService, channelPrefix);
    }
}
